export default "__VITE_ASSET__Dm_M59EC__"